const PromoSection = () => {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Left Card */}
          <div className="relative bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl p-8 overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/4"></div>
            <div className="absolute bottom-0 left-0 w-28 h-28 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/4"></div>
            <div className="relative">
              <p className="text-orange-100 text-sm font-semibold uppercase tracking-wide mb-2">New User Exclusive</p>
              <div className="text-white font-extrabold text-7xl leading-none mb-3">50%</div>
              <p className="text-white font-bold text-xl mb-1">Maximum Discount</p>
              <p className="text-orange-100 text-sm mb-6">For first-time joyagoo shoppers. Apply your coupon at checkout.</p>
              <a
                href="https://repsw2c.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white text-orange-600 font-bold rounded-xl hover:bg-orange-50 transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                Claim Discount
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>

          {/* Right Card */}
          <div className="bg-gradient-to-br from-amber-50 to-orange-50 border border-orange-100 rounded-2xl p-8 relative overflow-hidden">
            <div className="absolute top-4 right-4 w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full">
              <i className="ri-truck-line text-orange-500 text-2xl"></i>
            </div>
            <p className="text-orange-500 text-sm font-semibold uppercase tracking-wide mb-2">Shipping Deal</p>
            <h3 className="text-gray-900 font-extrabold text-3xl mb-2">Free Shipping</h3>
            <p className="text-gray-600 text-base mb-2">On orders over <strong>$50</strong> to worldwide destinations</p>
            <p className="text-gray-500 text-sm mb-6 leading-relaxed">
              Use a <strong>joyagoo shipping coupon</strong> to get free or discounted delivery on any order size. Updated codes available every week.
            </p>
            <a
              href="https://repsw2c.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-orange-500 text-white font-bold rounded-xl hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              Shop Now – Buy It Now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoSection;
